import { utils } from '@americanexpress/axp-field-validations-germany';
import { industryOptions, occupationOptions, professionOptions } from '../financialOptions';

const countryOptions = Object.entries(utils.countryNameCodes).map(([label, value]) => [{
  label,
  value,
}][0]);

export const getLabelOfValue = (value, options) => {
  if (!value || !options) return '';
  const selectedOption = options.find((option) => option.value === value);
  return selectedOption ? selectedOption.label : '';
};

export const getPrefix = ({ prefix }) => {
  switch (prefix) {
    case 'MR':
      return { prefixHerr: true };
    case 'MS':
      return { prefixFrau: true };
    default:
      return {};
  }
};

export const getTitle = ({ title }) => {
  switch (title) {
    case 'DOCTOR': // academicdegree_1 is legacy checkbox field
      return { titleDoctor: true };
    case 'PROFESSOR':
      return { titleProf: true };
    case 'PROFESSOR_DOCTOR':
      return { titleProfDoctor: true };
    default:
      return {};
  }
};

export const getDateOfBirth = ({ dateOfBirth }) => {
  const [day, month, year] = dateOfBirth.split('.');
  return {
    dobDay: day,
    dobMonth: month,
    dobYear: year.slice(-2),
  };
};

export const getDateFormatFromTimestamp = (timestamp) => {
  const submitDate = new Date(timestamp);
  return {
    date: submitDate.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: '2-digit' }).replace(/\./g, ''),
    hour: submitDate.getHours() > 9 ? String(submitDate.getHours()) : `0${submitDate.getHours()}`,
    min: submitDate.getMinutes() > 9 ? String(submitDate.getMinutes()) : `0${submitDate.getMinutes()}`,
  };
};

export const getPlaticColorForPlatinum = ({ plasticColor }) => {
  switch (plasticColor) {
    case 'PLATINUM':
      return { plasticPlatinum: true };
    case 'GOLD':
      return { plasticGold: true };
    case 'GREEN':
      return { plasticGreen: true };
    default:
      return {};
  }
};

const updateSubmitedValues = ({ values, pcn, timestamp }) => {
  const {
    prefix,
    title,
    firstName,
    middleName,
    lastName,
    nameOnCard,
    dateOfBirth,
    placeOfBirth,
    nationality,
    email,
    mobilePhoneNumber,
    streetName,
    houseNumber,
    postalCode,
    location,
    profession,
    industry,
    occupation,
    plasticColor,
  } = values;
  return {
    PCN: pcn,
    ...getPrefix({ prefix }),
    ...getTitle({ title }),
    firstName,
    lastName,
    nameOnCard,
    ...getDateOfBirth({ dateOfBirth }),
    placeOfBirth,
    nationality: getLabelOfValue(nationality, countryOptions),
    email,
    mobilePhoneNumber: `49${mobilePhoneNumber}`,
    street1: streetName,
    houseNumber,
    postalCode,
    location,
    middleName,
    ...getDateFormatFromTimestamp(timestamp),
    employmentStatus: getLabelOfValue(profession, professionOptions),
    industry: getLabelOfValue(industry, industryOptions),
    occupation: getLabelOfValue(occupation, occupationOptions[industry]),
    ...getPlaticColorForPlatinum({ plasticColor }),
  };
};

export default updateSubmitedValues;
